(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initTimer(el) {
    const endDate = new Date(el.dataset.endDate);
    if (isNaN(endDate)) return;

    const days    = el.querySelector('.timer-days');
    const hours   = el.querySelector('.timer-hours');
    const minutes = el.querySelector('.timer-minutes');
    const seconds = el.querySelector('.timer-seconds');

    function tick() {
      const diff = endDate - Date.now();
      if (diff <= 0) {
        el.closest('.announcement-timer-wrapper') &&
          (el.closest('.announcement-timer-wrapper').style.display = 'none');
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000)  / 60000);
      const s = Math.floor((diff % 60000)    / 1000);

      if (days)    days.textContent    = pad(d);
      if (hours)   hours.textContent   = pad(h);
      if (minutes) minutes.textContent = pad(m);
      if (seconds) seconds.textContent = pad(s);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initAll() {
    document.querySelectorAll('.announcement-timer[data-end-date]').forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when Shopify theme editor adds/reorders blocks
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();
